import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Button from '../buttons/Button';
import { CreateBankTransactionModel } from '../../../types/bankAccount';
import { Connection } from '../../../redux/slices/connectionsSlice';

type MatchVerificationProps = {
  matches: {
    mutation: CreateBankTransactionModel;
    matchedConnection?: Connection;
  }[];
  onConfirm: (
    confirmed: {
      transaction: CreateBankTransactionModel;
      matchedConnection: Connection;
    }[],
  ) => void;
};

export default function VerifyTransactionMatchesView({
  matches,
  onConfirm,
}: MatchVerificationProps) {
  const { t } = useTranslation('', { keyPrefix: 'page.financial.accountEntry' });

  const [confirmedMatches, setConfirmedMatches] = useState(() =>
    matches.map((m) => ({ ...m, confirmed: !!m.matchedConnection })),
  );

  const toggleConfirmation = (index: number) => {
    setConfirmedMatches((prev) =>
      prev.map((item, i) => (i === index ? { ...item, confirmed: !item.confirmed } : item)),
    );
  };

  const handleConfirm = () => {
    const filtered = confirmedMatches.filter((m) => m.confirmed && m.matchedConnection);
    onConfirm(
      filtered.map(({ mutation, matchedConnection }) => ({
        transaction: mutation,
        matchedConnection: matchedConnection!,
      })),
    );
  };

  const matchesToShow = confirmedMatches.filter((m) => !!m.matchedConnection);

  return (
    <div>
      {/*<h2 className="mb-4 text-lg font-semibold">Verify matches</h2>*/}
      <ul className="mb-4 space-y-4">
        {matchesToShow.length === 0 && <p>{t('noMatches')}</p>}
        {matchesToShow.map((match, index) => (
          <li
            // TODO fix key
            key={`${index}_match_${match.mutation.description}`}
            onClick={() => toggleConfirmation(index)}
            className="flex cursor-pointer items-center gap-4 rounded-lg border bg-white p-4 shadow-sm">
            <input
              type="checkbox"
              checked={match.confirmed}
              onChange={() => toggleConfirmation(index)}
            />
            <div className="flex flex-col">
              <div>
                <strong>{t('self')}:</strong> {match.mutation.description}
              </div>
              {match.matchedConnection && (
                <div className="text-success">
                  {t('matchedTo')}: {match.matchedConnection.fields.FIRST_NAME}{' '}
                  {match.matchedConnection.fields.LAST_NAME}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>

      <div className="flex justify-end gap-2">
        <Button variant="primary-dark" type="button" onClick={handleConfirm}>
          {t('continue')}
        </Button>
      </div>
    </div>
  );
}
